/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'thd-overlay',
    'utils.validate'
], function (
    $,
    pip,
    thdOverlay,
    thdValidate
) {

    var view = {
        selectors: {
            emailTrigger: '#sharebelt__email-a-friend',
            emailForm: '.sharebelt-email-template__form',
            emailFormInput: '.sharebelt-email-template__form .form-input__field',
            emailFormToField: '#sharebelt__email-to',
            emailFormFromField: '#sharebelt__email-from',
            emailFormToError: '#sharebelt__email-to ~ span.form-input-error__message',
            emailFormFromError: '#sharebelt__email-from ~ span.form-input-error__message',
            emailFormSendButton: '.sharebelt-email-template__button',
            emailFormSendButtonText: '.sharebelt-email-template__button .bttn__text',
            spinner: '.sharebelt-email-template__button .segment-spinner',
            emailResultContainer: '.sharebelt-email-template__result'
        },
        messaging: {
            success: "Great! You’ve shared this item with ",
            error: "We’re sorry, an unexpected error prevented your item from being shared. Please try again."
        },
        isSending: false,
        toggleEmailFormatError: function toggleEmailFormatError(formElement, errorMessageElement, validationResult) {
            $(formElement).parent().toggleClass('form-input--error', !validationResult);
            $(errorMessageElement).toggle(!validationResult);
        },
        updateEmailResultMessage: function updateEmailResultMessage(result) {
            var message = result ? view.messaging.success + model.toField + "." : view.messaging.error;
            $(view.selectors.emailResultContainer).text(message);
        },
        updateResultErrorState: function updateResultErrorState(result) {
            $(view.selectors.emailResultContainer).toggleClass('error-state', result);
        },
        emailFormClear: function emailFormClear() {
            $(view.selectors.emailForm)[0].reset();
        },
        setButtonDisabledState: function setButtonDisabledState(state) {
            $(view.selectors.emailFormSendButton).toggleClass('disabled', state);
        },
        toggleButtonSpinnerState: function toggleButtonSpinnerState() {
            view.isSending = !view.isSending;
            $(view.selectors.spinner).toggle(view.isSending);
            $(view.selectors.emailFormSendButtonText).toggle(!view.isSending);

        }

    };

    var model = {
        toField: null,
        fromField: null
    };


    function postEmailData() {
        return $.ajax({
            type: 'POST',
            url: '/p/svcs/sendProductEmail',
            data: JSON.stringify({
                'toAddress': model.toField,
                'fromAddress': model.fromField,
                'storeId': pip.customer.localStore && pip.customer.localStore.storenumber,
                'sku': pip.products.primary.data.itemId
            }),
            contentType: 'application/json',
            dataType: 'json'
        });
    }

    function initEventListeners() {
        $(document).off('click.emailTrigger', view.selectors.emailTrigger);
        $(document).on('click.emailTrigger', view.selectors.emailTrigger, function (e) {
            e.preventDefault();
            $('#sharebelt__share').tooltip('close');
            var overlayContent = document.createElement('div');
            overlayContent.innerHTML = view.template;

            var overlay = new thdOverlay({
                speed: '500ms',
                useContent: true,
                channel: pip.platformForCart,
                header: true,
                title: 'Email this Product',
                htmlNode: overlayContent,
                initialHeight: 300
            });

            overlay.open();
        });

        $(document).off('submit.emailSubmit', view.selectors.emailForm);
        $(document).on('submit.emailSubmit', view.selectors.emailForm, function (e) {
            e.preventDefault();
            if ($(view.selectors.emailFormSendButton).hasClass('disabled')) return;
            view.toggleButtonSpinnerState();
            view.setButtonDisabledState(true);

            postEmailData()
                .done(function(data) {
                    view.updateEmailResultMessage(true);
                    view.updateResultErrorState(false);
                    view.emailFormClear();
                })
                .fail(function() {
                    view.updateEmailResultMessage(false);
                    view.updateResultErrorState(true);
                    view.setButtonDisabledState(false);
                })
                .always(function () {
                   view.toggleButtonSpinnerState();
                })
        });

        $(document).off('keyup.emailFormInput blur.emailFormInput', view.selectors.emailFormInput);
        $(document).on('keyup.emailFormInput blur.emailFormInput', view.selectors.emailFormInput, function (e) {
            model.toField = $(view.selectors.emailFormToField).val();
            model.fromField = $(view.selectors.emailFormFromField).val();
            view.setButtonDisabledState(!shouldEnableSendButton(model.toField, model.fromField));
        });

        $(document).off('blur.emailFormFromField', view.selectors.emailFormFromField);
        $(document).on('blur.emailFormFromField', view.selectors.emailFormFromField, function (e) {
            model.fromField = $(view.selectors.emailFormFromField).val();
            view.toggleEmailFormatError(view.selectors.emailFormFromField, view.selectors.emailFormFromError, thdValidate.testEmail(model.fromField));
        });

        $(document).off('blur.emailFormToField', view.selectors.emailFormToField);
        $(document).on('blur.emailFormToField', view.selectors.emailFormToField, function (e) {
            model.toField = $(view.selectors.emailFormToField).val();
            view.toggleEmailFormatError(view.selectors.emailFormToField, view.selectors.emailFormToError, thdValidate.testEmail(model.toField));
        });

    }

    function bindDOMelements() {
        view.template = $('#sharebelt__email').html();
    }

    function shouldEnableSendButton(toField, fromField) {
        return thdValidate.testEmail(toField) && thdValidate.testEmail(fromField);
    }

    return {
        init: function () {
            initEventListeners();
            bindDOMelements();
        },
        shouldEnableSendButton: shouldEnableSendButton
    }

});

}.call(window));